export const habaCheckout = {
  habaOrderSummary: {
    subTotal: 'Warenwert',
    shipping: 'Versandkosten',
    totalDiscounts: 'Rabatte',
    total: 'Gesamtsumme',
    totalSavings: 'Gesamtersparnis:',
    safeSSL: 'Ihre Daten werden durch SSL-Verschlüsselung sicher übertragen.',
    help: 'Benötigen Sie Hilfe?',
    subHelp1: 'Kontaktieren Sie',
    subHelp2: 'hier unseren Kundenservice',
    giftCard: 'Gutschein*',
    giftCardsResidualValue: 'Restwert Gutschein',
    btn: {
      label_0: 'Adresse',
      label_1: 'Delivery',
      label_2: 'Weiter zur Zahlungsart',
      label_3: 'Weiter zur Übersicht',
    },
    orderNote: {
      title: 'Hinweis',
      placeholder: 'Wichtige Hinweise zu Ihrer Bestellung können Sie im Kommentarfeld hinterlegen.',
      label: '',
      error: '',
      wordCount: 'Verbleibende Zeichen: {{count}}',
      save: 'Kommentar speichern',
    },
  },
  habaConfirmation: {
    customerConfirmationTitle: 'Auswahl ändern?',
    customerConfirmationMessage: 'Wenn Sie Ihre Auswahl ändern, gehen die bereits eingegebenen Daten verloren. Möchten Sie trotzdem fortfahren?',
    customerConfirmationAcceptBtnMessage: 'Fortfahren',
    thankYouHeading: 'Vielen Dank für Ihre Bestellung',
    thankYouText:
      'Die Bestätigung Ihrer Bestellung und weitere Informationen zum Widerrufsrecht und Rückgabe erhalten Sie per E-Mail an folgende Adresse',
    pendingRegistrationReminderText:
      'Bitte bestätigen Sie Ihre E-Mail-Adresse, dann können wir Ihr Kundenkonto anlegen. Wir haben Ihnen eine E-Mail geschickt. Klicken Sie einfach auf den Bestätigungs-Link in der E-Mail.',
    total: 'Gesamtbetrag der Bestellung',
    haveOneSecond: 'Noch ein paar Sekunden Zeit?',
    pleaseConfirm: 'Bestätigen Sie Ihre E-Mail Adresse',
    securityPartOne:
      'Um die Sicherheit Ihres Kundenkontos zu gewährleisten haben wir eine Nachricht an ',
    securityPartTwo: ' geschickt.',
    confirmationLink:
      'Klicken Sie in der E-Mail auf den Bestätigungs-Link um die Einrichtung Ihres Kontos abzuschließen.',
    accountDeletion:
      'Sie können Ihr Kundenkonto erst verwenden nachdem die E-Mail Adresse bestätigt wurde! Aus Sicherheitsgründen wird andernfalls das Kundenkonto nach 2 Wochen wieder gelöscht.',
    myAccountRedirectMessage:
      'Den Status Ihrer Bestellung und die Sendungsverfolgung (sobald verfügbar) können Sie jederzeit in Ihrem Benutzerkonto unter "<a href="{{myOrders}}">Meine Bestellübersicht</a>" einsehen.',
    myAccountAfterConfirmMessage:
      'Nach der Bestätigung Ihres Kundenkontos können Sie den Status Ihrer Bestellung und die Sendungsverfolgung (sobald verfügbar) in Ihrem Benutzerkonto unter "Meine Bestellübersicht" einsehen.',
    orderDetailsRedirectGuestMessage:
      'Den Status Ihrer Bestellung und die Sendungsverfolgung (sobald verfügbar) können Sie jederzeit in der <strong><a href="{{myOrders}}">Bestellübersicht</a></strong> einsehen.',
    infoBoxMessage:
      'Bitte prüfen Sie den angegebenen Liefertermin auf ihrer Auftragsbestätigung. Kontaktieren Sie uns bitte, wenn Ihre Bestellung für eine <b>Einrichtung</b> bestimmt ist <b>und</b> der <b>Liefertermin in Ihren Schließzeiten liegt.</b>',
  },
  habaPayment: {
    description: {
      advancePayment:
        'Sie erhalten eine separate <strong>Auftragsbestätigung/Rechnung</strong> mit weiteren Zahlungsinformationen.',
      ct_creditcard_hop:
        'Sie werden nach dem Absenden der Bestellung zur Kreditkartenzahlung (HOP hosted order page) weitergeleitet.',
      ct_paypal:
        'Mit PayPal bezahlen ist einfach, schnell und sicher! Hinweis: Die Abfrage Ihrer Daten erfolgt nach dem Absenden der Bestellung. Sie müssen Ihre PayPal-Daten bei jedem Einkauf neu eingeben. Beim Bezahlen per PayPal wird auf die Website von PayPal weitergeleitet. Hierfür gelten die AGB von PayPal.',
      invoice:
        'Sie zahlen den Rechnungsbetrag ganz bequem per Überweisung innerhalb von 14 Tagen. Wir senden Ihnen die Rechnung vorzugsweise per E-Mail zu (PDF-Anhang). Zum Zwecke der Bonitätsprüfung können wir Ihre zur Adress- und Bonitätsprüfung erforderlichen Daten gegen die von der CRIF Bürgel GmbH gespeicherten Daten abgleichen. Die dort gespeicherten Daten beziehen auch Erkenntnisse aus mathematisch-statistischen Verfahren ein. Näheres hierzu können Sie unter diesem <a href="https://www.crif.de/datenschutz" target="_blank" rel="noopener noreferrer">Link</a> abrufen.',
    },
    disabledGiftcard:
      'Die Zahlungsmethode kann nicht in Verbindung mit einer Geschenkkarte benutzt werden.',
    paymentMethod: 'Zahlungsarten',
    paymentMethodEditState: 'Zahlungsart bearbeiten',
    personalDataEditState: 'Auftraggeber',
    selectionError: 'Bitte wählen Sie eine Zahlungsmethode.',
    button: 'Weiter',
    buttonEditState: 'Zahlungsart aktualisieren',
    disabledPaymentMethods: {
      ct_creditcard_hop:
        'Leider können wir aktuell keinen Kauf per Kreditkarte anbieten. Bitte wählen Sie eine alternative Zahlart.',
      ct_paypal:
        'Leider können wir aktuell keinen Kauf per PayPal anbieten. Bitte wählen Sie eine alternative Zahlart.',
      invoice:
        'Leider können wir aktuell keinen Kauf auf Rechnung anbieten. Bitte wählen Sie eine alternative Zahlart.',
      advancePayment:
        'Leider können wir aktuell keinen Kauf auf Vorkasse anbieten. Bitte wählen Sie eine alternative Zahlart.',
    },
    disabledDescription: {
      ct_paypal:
        'Sie haben Produkte in Ihrem Warenkorb, die für Sie produziert werden. Hier können wir Ihnen momentan nur Rechnung oder Vorauskasse als Zahlungsarten anbieten.',
      ct_creditcard_hop:
        'Sie haben Produkte in Ihrem Warenkorb, die für Sie produziert werden. Hier können wir Ihnen momentan nur Rechnung oder Vorauskasse als Zahlungsarten anbieten.',
      advancePayment:
        'Bitte beachten Sie, dass die Zahlungsart Vorkasse nicht zusammen mit einem Gutscheinen verwendet werden kann.',
    },
    birthdateModal: {
      title: 'Bitte weisen Sie Ihre Identität nach',
      paragraph:
        'Für diese Zahlungsmethode benötigen wir zusätzliche Daten zum Nachweis Ihrer Identität. Danach können Sie Ihren Einkauf abschließen.',
      dataProtection: 'Datenschutzerklärung',
      inputPlaceholder: 'Geburtstag (TT.MM.JJJJ)',
      submitButton: 'Bestätigen',
      dataProtectionLink: 'Datenschutzerklärung',
      dataProtectionText: 'Es gilt unsere',
    },
    giftcardRedemptionDisabledTitle: 'Gutscheine können mit der Zahlungsart Vorkasse nicht eingelöst werden',
    giftcardRedemptionDisabledDescription: 'Bitte wählen Sie eine andere Zahlungsart, wenn Sie einen Gutschein einlösen möchten.',
    giftcardRedemptionDisabledButton: 'Ohne Gutschein fortfahren',
    giftcardRedemptionDisabledButtonSubmit: 'Zahlungsart ändern'
  },
  habaPlaceOrder: {
    agb: 'Ja, ich stimme den AGB zu.',
    dataProtection: 'Unsere Datenschutzerklärungen finden Sie hier.',
    placeOrder: 'Jetzt Kaufen',
    error: 'Ein Fehler ist aufgetreten.',
  },
  habaGuestLogin: {
    next: 'Weiter',
    title: 'Ich bin Neukunde im Online-Shop',
    heading: 'Als Gast bestellen',
    emailAddress: {
      label: 'E-Mail Adresse',
      error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    emailConfirmationAddress: {
      label: 'E-Mail Adresse bestätigen',
      error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    button: 'Zur Gastbestellung',
  },
  habaCheckoutProgress: {
    login: 'Anmelden',
    methodOfPayment: 'Method of Payment',
    billingAddress: 'RECHNUNGS&shy;ADRESSE',
    shippingAddress: 'LIEFER&shy;ADRESSE',
    address:'ADRESSE',
    customerData:'Kundendaten',
    deliveryMode: 'Delivery Mode',
    paymentDetails: 'ZAHLUNG',
    authorizePayment: 'Authorize Payment',
    reviewOrder: 'BESTÄTIGEN',
  },
  habaCheckoutReview: {
    pendingRegistration: {
      title: 'Ihre Neu-Registrierung wird noch bearbeitet',
      durationBefore: 'Dies kann',
      duration: 'bis zu einem Werktag',
      durationAfter:
        'dauern. Sobald die Bearbeitung abgeschlossen ist, erhalten Sie eine Bestätigungs-E-Mail.',
      impactTitle: 'Was bedeutet das für Ihre Bestellung?',
      noConditions:
        'Für neue Geschäftskunden oder Unternehmen ohne individuelle Konditionen entstehen keine Einschränkungen.',
      existingConditions:
        'Bestehen bereits individuelle Firmenkonditionen oder Rahmenverträge, stehen diese erst nach der Bestätigung zur Verfügung.',
      orderNow:
        'Sie können jetzt zu den angezeigten Konditionen bestellen oder die Bestätigungs-E-Mail abwarten.',
    },
    review: 'Ihre Übersicht',
    cardTitle: {
      shippingAddress: 'Lieferadresse',
      billingAddress: 'Rechnungsadresse',
      contactPerson: 'Ansprechpartner der Lieferung',
      client:'Auftraggeber',
      clientContactPerson:'Ansprechpartner des Auftraggebers',
      emailInvoice: 'E-Mail-Adresse für Rechnungsversand',
      paymentMethod: 'Zahlungsart',
      deliveryMethod: 'Versandart',
    },
    default: 'Standard',
    errors: {
      syncAtpCheckProductNotAvailable:
        'Bestand nicht mehr verfügbar. Ein oder mehrere Produkte wurden aus Ihrem Einkaufswagen entfernt.',
      syncAtpCheckProductQuantityChanged:
        'Bestand nicht mehr verfügbar. Bei einem oder mehreren Produkten wurden die Mengen verringert.',
      generic:
        'Bestellung kann nicht abgeschlossen werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unser Support-Team',
      syncAtpCheckProductNotAvailableQuantityChanged:
        'Bestand nicht mehr verfügbar. Ein oder mehrere Produkte wurden aus Ihrem Einkaufswagen entfernt & bei einm oder mehreren Produkte wurden die Mengen verringert.',
      cartItemsPriceChanged:
        'Produktpreise wurden aktualisiert. Bitte prüfen sie erneut Ihre Bestellung',
      cartChanged: 'Ihr Warenkorb wurde aktualisiert.',
      giftCardsRemoved:
        'Eine oder mehrere Geschenkkarten wurden entfernt. Bitte fügen Sie diese erneut hinzu.',
      invalidPaymentDetails: 'Bitte aktualisieren Sie Ihre Zahlungsmethode',
      companyAddressesChanged:
        'Ihre Firmendaten haben sich geändert. Bitte wählen Sie Ihre Adressen erneut aus.',
      genericpayment:
        'Während der Kontaktaufnahme zum Zahlungsanbieter ist ein Problem aufgetreten. Warte einige Minuten und versuche es erneut oder wähle eine andere Zahlungsmethode. Wenn das Problem weiterhin auftritt, wende dich an unser Kundenservicecenter.',
      paymentcanceled:
        'Der Bezahlvorgang wurde abgebrochen. Bitte wählen Sie eine Zahlungsmethode, um fortzufahren.',
      orderFromCartAlreadyExists:
        'Für Ihren Warenkorb ist bereits eine Bestellung eingegangen. Bitte prüfen Sie Ihre E-Mails oder kontaktieren unseren Kundenservice.',
      missingPriceSimulate:
        'Bitte überprüfen Sie noch einmal den Inhalt Ihres Warenkorbs. Bei der Verfügbarkeitsprüfung ist ein Fehler aufgetreten, der eine Anpassung der Artikelliste oder Bestellmengen zur Folge hatte.',
      purchaseGiftcardsAndRedemption:
        'Die Gutscheineinlösung wurde entfernt. Beim Kauf von Wertgutscheinen kann kein Gutschein als Zahlungsmittel verwendet werden',
    },
  },
  habaCheckoutFooter: {
    infoservice: {
      headline: 'KUNDENSERVICE',
      schedule: 'Montag - Freitag 8-16 Uhr',
      telephone: {
        DE: '+49 9564 929 60013',
        AT: '+43 732 210 002',
      },
      email: 'kontakt@wehrfritz.com',
    },
    orderservice: {
      headline: 'BESTELLSERVICE',
      schedule: 'Montag - Freitag 8-16 Uhr',
      telephone: {
        DE: '+49 9564 929 60316',
        AT: '+43 732 210 001'
      },
      email: 'bestellungen@wehrfritz.com',
    },
    contact: {
      headline: 'KONTAKT',
      text: 'Kontaktformular',
    },
    information: {
      headline: 'HINWEISE',
      text: 'Alle Angaben in EUR, inkl. MwSt. zzgl. Versand- und Servicekosten.',
    },
    orderInformation: {
      headline: 'BESTELLHINWEISE',
      text: 'Kein Mindestbestellwert. Bitte beachten Sie, dass die Artikel in ihrem Einkaufskorb nicht reserviert sind.',
    },
    links: {
      cookieSettings: 'Cookie-Einstellungen',
      gtc: 'AGB',
      imprint: 'Impressum',
      privacyNotice: 'Datenschutzerklärung',
    },
  },
};
